var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "-12798 10930 28.77 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-12769.232 10934.691v.085a5.406 5.406 0 0 1-1.523 3.768q-1.258 1.464-17.528 19.964a.949.949 0 0 1-.334.258q-2.007.732-8.011 3.234h-.3c-.031 0-.068.005-.105.005a1.1 1.1 0 0 1-.629-.2 1 1 0 0 1-.338-.75.98.98 0 0 1 .032-.258q1.819-8 1.909-8.458a.9.9 0 0 1 .2-.492l17.471-20.009a5.054 5.054 0 0 1 3.577-1.83c.091-.005.181-.008.271-.008a4.777 4.777 0 0 1 3.229 1.251 5.085 5.085 0 0 1 2.074 3.412zm-25.736 21.782q-.53 2.241-.76 3.152 1-.37 3.152-1.291t2.708-1.141a5.659 5.659 0 0 0-1.569-2.265 5.566 5.566 0 0 0-2.814-1.471zm12.149-16.519l-6.083 7-4.192 4.8a8.759 8.759 0 0 1 2.921 1.709 7.467 7.467 0 0 1 1.742 2.27q10.884-12.317 14.626-16.62a5.363 5.363 0 0 0-1.733-2.724 5.919 5.919 0 0 0-2.873-1.462zm11.636-5.073a3.162 3.162 0 0 0-1.33-2.1 3.012 3.012 0 0 0-2.114-.873h-.041a3.236 3.236 0 0 0-2.224 1.224l-.115.137a9.062 9.062 0 0 1 2.739 1.66 7.606 7.606 0 0 1 1.872 2.486l.19-.144a3.518 3.518 0 0 0 1.021-2.386z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.575ecfd1.svg";
export { ForwardRef as ReactComponent };